// @ts-nocheck

import config from '../../../config/app.config';
import { getLang } from '../../../i18n/l10n';
import { ClientUpdaterActionTypes } from '../types/actions/clientUpdater';

export const dismissUpdate = () => ({
  type: ClientUpdaterActionTypes.DISMISS_UPDATE,
});

export const update = () => (dispatch) => {
  dispatch({
    type: ClientUpdaterActionTypes.UPDATE,
  });

  // Work only for iOS atm
  // Redirect to the AppStore
  const lang = getLang();
  const updateBundleUrl = config.updateBundleUrl[lang]
    .replace(/\$\{store\}/g, window.getAppStore())
    .replace(/\$\{id\}/g, window.getAppBuildId());
  window.location.assign(updateBundleUrl + '&external=1');
};

const actions = {
  dismissUpdate,
  update,
};

export default actions;
